import { render, staticRenderFns } from "./ProjectSummaryCompletedStatsFunded.vue?vue&type=template&id=9b102872"
import script from "./ProjectSummaryCompletedStatsFunded.vue?vue&type=script&lang=js"
export * from "./ProjectSummaryCompletedStatsFunded.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports